import React from 'react';
import './SpeakerCard.css';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import { Container, Row, Col, ListGroup  } from 'react-bootstrap';


const Initial = () => {
  return (
    <Container>
      <Row>
        <Col>
          <p>Initial conversations held by the team were strongly influenced by our host university's, Learning Planet Institute ethos, which is centered around the UN's sustainable development goals. As we browsed through past iGEM projects, we were struck by the few projects that looked into sexual health. We decided we wanted to contribute to this field. Initially, we identified we were contributing to SDG3. As the project moved on, we realized we were also contributing to SDG4, SDG5, SDG8, SDG9, and SDG12.</p>
        </Col>
      </Row>
    </Container>
  );
}

const WhitePaper=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            <strong>White papers</strong> are authoritative, research-based documents that present information, expert analysis, and an organization/author's insight into a topic or solution to a problem.
          </p>
          <p>
            The <strong>United Nations</strong> is an intergovernmental organization whose stated purposes are to maintain international peace and security, develop friendly relations among nations, achieve international cooperation, and serve as a center for harmonizing the actions of nations.
          </p>
          <p>
            We looked into all the different UN agencies that could provide us insight into our problem at hand. We identified <strong>4 main relevant actors</strong> and read through related literature:
          </p>
          <ul>
            <li>
              The <strong>World Health Organization</strong>, of which we highlight two reports: the Global health sector strategies on, respectively, HIV, viral hepatitis, and sexually transmitted infections for the period 2022-2030; and the "Guidelines on self-care interventions for health and well-being, 2022 revision"
            </li>
            <li>
              The <strong>United Nations Population Fund</strong> (UNFPA), a UN agency entirely aimed at improving reproductive and maternal health. Their 2022 guide on lubricant procurement was very useful to our product design.
            </li>
            <li>
              The <strong>Joint United Nations Programme on HIV/AIDS</strong> (UNAIDS), the main advocate for accelerated, comprehensive, and coordinated global action on HIV/AIDS.
            </li>
            <li>
              The <strong>United Nations Educational, Scientific and Cultural Organization</strong> (UNESCO) <strong>Chair on Global Health & Education</strong> focuses on improving children and young people's health, promoting intersectoral policies and practices.
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const FranceSexualHealth=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Because we are based in France, we also looked into France's specific public health strategy. We looked at the most recent&nbsp;
            <strong>feuille de route</strong>.
            Overall, the WHO and French strategy share similar guiding principles.
          </p>
          <p>
            Published in November 2021, as part of a broader national sexual health strategy outlined in 2017, this report is as part of a&nbsp;
            <strong>co-constructive interdepartmental effort to build a pluriannual sexual health strategy for France</strong>.
            Moving towards a "pluriannual" framework, despite the French social security law (loi de financement de la sécurité sociale) being voted anew each year, is key to ensuring continuity of care provision and capacity building.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const EUSexualHealth=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>We also checked whether any interesting and relevant work had been done at an <strong>EU level</strong>. The</p>
          <p><strong>European Centre for Disease Prevention and Control's</strong> (ECDC) sexually transmitted infections webpage provides European citizens with updates, news, and publications on the state of sexual health in the EU. The most interesting information we got from researching their website is that of the existence of a <strong>Dublin Declaration on partnership to fight HIV/AIDS in Europe and Central Asia,</strong> signed in 2004, that sets up the guidelines to monitor and evaluate the implementation of actions every two years. It is interesting to consider it enables countries within to report epidemiological data directly to the ECDC rather than UNAIDS.</p>
        </Col>
      </Row>
    </Container>
  );
}

const Frameworks=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>Human practices can sometimes be a little overwhelming because one does not know where to start. Here we outline some of the tools and readings we used to inform the development of an intersectional systems-led approach to design and human practices.</p>
        </Col>
      </Row>
    </Container>
  );
}

const PublicHealthDefinitions=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>Definitions are important. Here are some key public health concepts that guided our human practices.</p>
        </Col>
      </Row>
    </Container>
  );
}

const hiddenliveshiddengems=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            We would also like to mention the research collective&nbsp;
            <strong>Hidden Lives Hidden Gems</strong>&nbsp;(HLHG), whose work on the notion of lived experience and co-creation, informed the design and conduction of interviews and surveys.
            Laure, within our team, is part of it.
          </p>
          <p>
            Based in London, HLHG is a collective of researchers from different backgrounds (public health, art, patient experience, anthropology, medicine, etc.) that aims to challenge definitions of academic linguo.
            Last year, their first symposium focused on defining qualitative and quantitative tools to evaluate user's&nbsp;
            <strong>lived experience</strong>.
            This year, they are hosting a second symposium on&nbsp;
            <strong>co-creation</strong>.
          </p>
          <p>
            They define&nbsp;
            <strong>
              <em>lived experience</em>
            </strong>
            &nbsp;as first-hand, in the moment engagement with what is perceived and felt as individual reality.
            <strong>
              <em>Co-creation</em>
            </strong>
            &nbsp;is defined as a way of working together that enables everyone involved to participate in a reflexive, dynamic process, where inclusivity and equality are central to the outcome.
            They specify:
            <strong>
              <em>co-creation</em>
            </strong>
            &nbsp;happens when there is&nbsp;
            <strong>open engagement</strong>
            &nbsp;with all participants, when it is grounded in&nbsp;
            <strong>mutual respect</strong>
            &nbsp;and acknowledges the&nbsp;
            <strong>holistic benefits to all</strong>.
            This way of working means that there is the potential for organic&nbsp;
            <strong>creative growth</strong>, enabling&nbsp;
            <strong>connectivity</strong>,&nbsp;
            <strong>social equity</strong>, and&nbsp;
            <strong>equanimity</strong>&nbsp;to emerge.
          </p>
          <p>
            Reflecting on these definitions as a team has been a key guiding principle of our human practice work.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Exposees=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Sexual health is an intimate part of every unique experience. As a group, we felt art & creative mediums would provide a window into pleasures, pains, and struggles citizens could experience, informing our understanding of the field.
            From February to May 2023, the Palais de Tokyo, an institution dedicated to modern and contemporary art, was hosting an exhibition titled "Exposé.e.s," based upon art history critic Elisabeth Lebovici's "Ce que le sida m'a fait- art and activisme à la fin du XXe siècle." Some of us were lucky to attend.
          </p>
          <p>Key take-aways:</p>
          <ul>
            <li>The HIV/AIDS epidemic is still ongoing and continues to impact artistic practices</li>
            <li>Community health and counterculture are key to making up for the government's lack of appropriate action in the face of epidemics</li>
            <li>The HIV/AIDS epidemic and its lived experience are angering, rage-inducing, heartbreaking.</li>
            <li>Understanding subculture is key to developing an easy-to-use and efficient product.</li>
          </ul>
          <p>
            They define&nbsp;
            <strong>
              <em>lived experience</em>
            </strong>
            &nbsp;as first-hand, in-the-moment engagement with what is perceived and felt as individual reality.
            <strong>
              <em>Co-creation</em>
            </strong>
            &nbsp;is defined as a way of working together that enables everyone involved to participate in a reflexive, dynamic process, where inclusivity and equality are central to the outcome.
            They specify:
            <strong>
              <em>co-creation</em>
            </strong>
            &nbsp;happens when there is&nbsp;
            <strong>open engagement</strong>
            &nbsp;with all participants, when it is grounded in&nbsp;
            <strong>mutual respect</strong>
            &nbsp;and acknowledges the&nbsp;
            <strong>holistic benefits to all</strong>.
            This way of working means that there is the potential for organic&nbsp;
            <strong>creative growth</strong>, enabling&nbsp;
            <strong>connectivity</strong>,&nbsp;
            <strong>social equity</strong>, and&nbsp;
            <strong>equanimity</strong>&nbsp;to emerge.
          </p>
          <p>
            Reflecting on these definitions as a team has been a key guiding principle of our human practice work.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Tickson=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Mbuyi Tickson is a Parisian-based Congolese artist. One of his key works is his performance
            titled <strong>"l'homme Capote"</strong>, which translates as "condom man." We met him at the
            Palais de Tokyo exhibition, and he kindly agreed to let us feature his work. The costume is intended
            as an invitation to reflect on preventative methods in reproductive and sexual health. Tickson wears
            it at the Bon Marché district of Kinshasa, a popular nightlife neighborhood, in an attempt to draw
            attention to the "inconsistent use of condoms in the DRC."
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Facettes=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            As part of our outreach, we also attended <strong>festivals related to sexual health</strong>. Facettes is a Paris-based youth mental health festival.
          </p>
          <p>
            Because <strong>sexual and mental health are intimately related</strong>, a number of stands and workshops featured work on sexuality.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Key take-aways:</p>
          <ul>
            <li>Mental and sexual health are intimately related.</li>
            <li>Co-creating elements of language in a grassroots approach is the way forwards for ultimate user experience.</li>
            <li>Critical insight into different resources around sexual health.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const PopCulture=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>Just looking around us in <strong>Paris</strong> and <strong>online</strong>, we stumbled onto <strong>a lot of content</strong> (advertisement, pop culture, other) that informed our understanding of sexual health and sexuality. We've compiled a little list of some of the content that struck us over our iGEM months.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p><strong>Key take-aways:</strong></p>
          <ul>
            <li>Informing our product design and the language we use to talk about our science to lay audiences.</li>
            <li>Informing our own understanding of current sexual practices, taboos, and where the demand for lubricants is.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const PatientX=()=>
{
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <p>Talking with <strong>patients</strong> was key to the development of our product. Patient [x], living with seropositivity, has decided to stay anonymous but kindly agreed for us to share the content of our conversation.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <strong>Key take-aways:</strong>
        </Col>
      </Row>
      <Row>
        <Col>
          <ListGroup as="ul">
            <ListGroup.Item as="li">The importance of treatment and preventive options</ListGroup.Item>
            <ListGroup.Item as="li">PrEP is used very commonly within the MSM Parisian community. Lubritect could be a fantastic alternative.</ListGroup.Item>
            <ListGroup.Item as="li">Patients don't necessarily have the time to get involved but they are often keen for scientific information to be clearly communicated their way.</ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
}

const Akuma=()=>
{
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <p>Talking with patients was key to the development of our product.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Laurence Rouloff has been an <strong>oral HPV carrier</strong> since she was 6. Lived experience of the disease pushed her to create <strong>Akuma</strong>, an association dedicated to increasing awareness of HPV and ways to prevent it. You can check their work out{' '}
            <a href="https://www.associationakuma.fr/">here</a>.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <strong>Key take-aways:</strong>
          </p>
          <ul>
            <li>Accessing scientific information for non-professionals is not easy, giving way for the spread of misinformation.</li>
            <li>Our product design and brand storytelling should clearly communicate the types of protection our product offers.</li>
            <li>
              Akuma’s mission inspired us to develop an{' '}
              <a href="https://static.igem.wiki/teams/4602/wiki/sexual-health-guide.pdf">Introductory Guide to Sexual Health</a>.
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Gyneco=()=>
{
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <p>
            Talking with <strong>healthcare practitioners</strong> was also key. Fabienne Delay-Sineau is a Nantes-based gynecologist and ultrasound expert. We met with her to discuss the relevance of the product we were developing.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <strong>Key take-aways:</strong>
          </p>
          <ul>
            <li>Microbicides & lubricants with antiviral properties could and should be used more by the French medical community.</li>
            <li>Lubritect is particularly relevant to populations that cannot be vaccinated (&gt;25yo).</li>
            <li>Prospective diagnostic applications of our technology could be a great innovation.</li>
            <li>Prospective applications, outside of the field of STIs (for e.g. echography, surgery) are welcome.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Claire=()=>
{
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <p>
            Yet healthcare professionals aren't only in the hospital. Claire Versini is a <strong>psychomotrician</strong> (the French equivalent of a physical therapist), currently completing a university diploma in sexual health, with a <strong>specialization in mental health.</strong>
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p><strong>Key take-aways:</strong></p>
          <ul>
            <li>Building well-thought through educative content is going to be key to our product's market access.</li>
            <li>Sexual health is still a huge taboo. A solution rather than risk-based approach to the topic is key.</li>
            <li>The scientific basis of our project needs to be communicated clearly to the lay-public.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Lusignan=()=>
{
  return (
  <Container className="mt-5">
  <Row>
  <Col>
  <p>The <strong>CRIPS</strong> (Centre Régional d'Information et de Prévention du Sida et pour la santé des jeunes), founded in 1988, is the organism affiliated to the Île de France region, <strong>in charge of developing prevention policies in the area.</strong> To do so, the association collaborates with institutions, non-governmental associations and private entities.</p>
  </Col>
  </Row>
  <Row>
  <Col>
  <p>Jean-Baptiste Lusignan is in charge of the <strong>prevention team</strong> with the CRIPS structure. We sat down with him to better understand what the landscape of STI is looking around in Île de France, and see whether Lubritect truly could help bridge a needed gap.</p>
  </Col>
  </Row>
  <Row>
  <Col>
  <p><strong>Key take-aways:</strong></p>
  <ul>
  <li>Technical scepticism and weariness linked to past failures in the field could play against us.</li>
  <li>Lubritect elegantly fits within the public health strategy of combination prevention.</li>
  <li>Our product could fit within universal health coverage schemes and could learn from related implementation trials.</li>
  <li>A patient-centered flexible and non-judgmental approach is the way forward in the field of sexual health.</li>
  </ul>
  </Col>
  </Row>
  </Container>
  );
  }

const Slow=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>2023 is the <strong>year of climate boiling</strong>. For us as a team, it was key to conceive and design our product with its ecological impact in mind from the very start. For this, we got in touch with both the <strong>Slow Cosmétique Association</strong>, an NGO based in Belgium, and the French e-commerce start-up <a href="http://slow-cosmetique.com/">slow-cosmetique.com</a>.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>We sat down for a phone exchange with founder Julien Kaibeck, from the Association, and exchanged some emails with co-founder Gilles Davignon, from <a href="http://slow-cosmetique.com/">Slow-cosmetique.com</a>.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <strong>Key take-aways:</strong>
          <ul>
            <li>Clear language elements both from a product and scientific stand-point necessary</li>
            <li>Mucin + protein powder model not viable on the long-run</li>
            <li>Options for product packaging</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Dolbois=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>Pierre Fabre is a <strong>French multinational pharmaceutical and cosmetics company</strong>. If the company does not work specifically on sexually transmitted infections, they are a key figure in the French pharmaceutical landscape. They also stand out through their shareholding strategy: 86.32% of shares are held by Pierre Fabre Participations, the group&#39;s Foundation, enabling 9.53% (2005 employee shared ownership plan) of employees to be shareholders and for investments to be made in the long run.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Laurence Dolbois has been working at Pierre Fabre for the last 25 years. Currently, she is <strong>compliance manager</strong> in the <strong>International Ethics &amp; Compliance department</strong>, but has also served as International Pharmaceutical Affairs Director, Regulatory Compliance Director, and initially as toxicology project director. Regulatory compliance is an integral part of pharmaceutical companies' work. These ensure processes and procedures undertaken by the company adhere to all relevant laws, regulations, and standards. We sat down to talk with her about her experience and what she had to teach us about bringing a new medical device to the market.</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <strong>Key take-aways:</strong>
          <ul>
            <li>Overall systems thinking of our product design will ensure success.</li>
            <li>Necessity to fit within the current compliance framework using tools like EcoVadis or Pierre Fabre Green Index.</li>
            <li>Key components of business development include benchmarking, supply chain monitoring, pricing, accessibility, and communication campaigns.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Gibert =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>Audrey Gibert is a freelance consultant and trainer in the field of <strong>quality &amp; regulation of medical devices</strong>. With a very busy start of the year, Audrey was kind enough to grant us some of her time and answer our questions! </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p><strong>Key take-aways:</strong>
          <ul>
            <li>We are a borderline medical device: we are a medicinal product used in combination with a medical device.</li>
            <li>This implies some extra paperwork and legislation.</li>
            <li>As a biotech, there are a few notified bodies in France/ EU that can approve of our CE labeling.</li>
          </ul></p>
        </Col>
      </Row>
    </Container>
  );
}

const Elena =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            <strong>Elena Tricca</strong> is currently the{' '}
            <strong>Vice President of Global Market Access & Pricing</strong> for
            BioPharmaceuticals at AstraZeneca. AstraZeneca is a global, science-led
            biopharmaceutical business.
          </p>
          <p>
            <strong>Key take-aways:</strong>
          </p>
          <ListGroup as="ul">
            <ListGroup.Item as="li">
              We could develop <strong>differently priced brands</strong> of lubricant.
            </ListGroup.Item>
            <ListGroup.Item as="li">
              In the initial stages of market access, when targeting customer niches are narrow,
              <strong>being 5-6€ over market price</strong> for lubricant is OK if we are offering a medical service.
              It should drop when we reach the general market customer.
            </ListGroup.Item>
            <ListGroup.Item as="li">
              Lubricants <strong>should be our comparator</strong> on the market because we are NOT replacing condoms.
              We can, however, still have a look at the condom market as we might be able to gain market shares there.
            </ListGroup.Item>
            <ListGroup.Item as="li">
              We must look into <strong>over-the-counter regulation of medication</strong> and{' '}
              <strong>medical devices</strong> more closely before we make a final choice on our product classification.
            </ListGroup.Item>
            <ListGroup.Item as="li">
              We need to think more thoroughly about <strong>which regulation</strong> would apply to our{' '}
              <strong>advertisement campaign</strong>. Typically, while we found the launching campaign by Conrad in the US,
              we must clarify whether it is legal to carry out a similar campaign in Europe.
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
}

const Tessa=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Tessa Beccaria is a student in public affairs currently working part-time at Jeen. Jeen is a women's health space, recently opened in Paris, with a strong value-driven identity. We wanted to get in touch to discuss women's sexual health, potential partnership, and branding.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Valentin=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Christine Valentin is a <strong>freelance consultant</strong> at her own company, <strong>Batzine</strong>. She has been the Vice President of Business Strategy and Development for multiple firms over her career.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <strong>Key take-aways:</strong>
          </p>
          <ul>
            <li>
              At all times, it should be highlighted that the product is both for pleasure, as well as for safety/health. This is also a good basis for a marketing strategy - <strong>for pleasure, in the service of sexual health</strong>.
            </li>
            <li>Patenting the proteins/formulation is crucial before moving onto clinical trials and production.</li>
            <li>Law experts are necessary to help out with the details of intellectual property and the patenting process.</li>
            <li>Partnering up with NGOs that work towards betterment of women’s health and LGBTQ+ wellness could increase outreach and provide more context and feedback from the users.</li>
            <li>The LGBTQ+ community, in addition to women experiencing (peri)menopause should be our target demographic.</li>
            <li>Women empowerment, or more generally, letting our demographic get back their agency with respect to sexual health and wellness ought to be a part of a successful strategy.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Morel=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            We had the pleasure to sit down for an all-embracing entrepreneurship
            talk with <strong>Mehdi Morel</strong>, a scientific partnerships
            manager at <strong>Owkin</strong>.
          </p>

          <p>
            <strong>Key take-aways</strong>
          </p>

          <ul>
            <li>
              Business plans are prone to change - we should constantly ask,
              listen, reassess and revise our strategies and estimates
            </li>
            <li>Writing down our concerns and potential risks is very valuable.</li>
            <li>
              Develop a few user personas which are representative of the niche
              customer segment we are primarily targeting.
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Antoine=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Antony Sar is a doctor in pharmacy and game creator. We met with him
            to discuss immunology related games he'd developed over the last two
            years and see how we could implement some of his learnings into our
            workshop design.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Outreach =()=>
{
  return (
    <Container>
      <p>
        Throughout the project, we engaged with the Learning Planet Community, attending and presenting at institutional lab meetings, and presenting our work as part of the Institute's Discovery Days. We also engaged with the iGEM community throughout online meetings and in-person events. Importantly, we also shared our understanding & knowledge of virology and synthetic biology with the Parisian community. You can read more about this on our Outreach & Education page.
      </p>
    </Container>
  );
}

const Microbicides =()=>
{
  return (
    <Container>
      <p>Microbicides are experimental products that can be applied or inserted into the vagina or rectum to prevent sexually transmitted infection acquisition. Find out how we went about learning more about these.</p>
    </Container>
  );
}

const Harvard =()=>
{
  return (
    <Container>
      <p>
        <strong>Harvard's TH Chan School</strong> is one of the leading research centers in Public Health. In September 2023, the school hosted a <strong>high-level conversation</strong> on the current STI surge in the US.
      </p>
      <p>
        <strong>Key take-aways:</strong>
      </p>
      <ListGroup as="ul">
        <ListGroup.Item as="li">Public-private partnership and corporate responsibility are key to developing adequate public health responses.</ListGroup.Item>
        <ListGroup.Item as="li">Relatedly, the societal dimension of sexual health needs to be acknowledged. Our approach, prescription-free, bedroom-designed, fits within this paradigm.</ListGroup.Item>
        <ListGroup.Item as="li">There is a clear innovation gap we can contribute to.</ListGroup.Item>
        <ListGroup.Item as="li">And much more!</ListGroup.Item>
      </ListGroup>
    </Container>
  );
}

const Ethics =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Throughout our research, a series of ethical considerations came to our attention. These include unintended consequences, psychosocial harm, public mistrust of science. We strongly recommend taking the time to read our take-aways from this research.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Auvert =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            <strong>Bertran Auvert</strong> is a retired INSERM research and medical practitioner whose work has focused, among other topics, on the reduction of HIV transmission in sub-Saharan Africa. You can find a complete list of his work at the{' '}
            <a href="https://scholar.google.fr/citations?user=NfGi3TcAAAAJ&amp;hl=fr">following link</a>.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <strong>Key take-aways:</strong>
          </p>
          <ul>
            <li>Quantitative and qualitative studies are necessary prior to clinical trials.</li>
            <li>It is impossible to predict the behavior of target populations; it requires evidence-based implementation trial.</li>
            <li>The pleasure aspect of our product is a key advantage relative to other alternatives.</li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

const Baker =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Dr. Alexis Courbet, from Maker Lab, provided valuable insights and guidance that significantly enhanced our protein design project for iGEM 2023. His expertise in de novo protein design and prompt responses to our questions were invaluable to our team's success.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const Bomsel =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Whilst we continued to inform our understanding of sexual health and devise our lubricant, we also reached out to scientists in the field. They have helped us understand where the most recent science was at and how to devise experimental pipelines which would provide the most concrete research evidence.
          </p>
          <p>
            Among the first points of contact for us was <strong>Dr. Morgane Bomsel</strong>. She is the leader of Mucosal Entry of HIV and Mucosal Immunity team at the <strong>Institut Cochin</strong> in Paris, France. You can find out more about her work <a href="https://scholar.google.fr/citations?hl=fr&user=EEVoCSIAAAAJ">here</a>.
          </p>
          <p><strong>Key take-aways:</strong></p>
          <ListGroup as="ul">
            <ListGroup.Item as="li">Different experimental models should be used for an in-depth understanding of the molecular mechanisms of our conceived proteins</ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
}

const CNPR =()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            As our proof of concept is focusing in part on developing a lubricant against HPV, we also got in touch with experts at the <strong>Centre national de référence Papillomavirus</strong> (CNRP), the national centre for reference on HPV, which has been appointed by the French public health agency (Santé Publique France) and the Directorate General of Health (Direction général de la Santé) the task of monitoring papillomavirus infections at a microbiological level.
          </p>
          <p>
            Professeur <strong>Jean-Luc Prétet</strong>, director of the CNRP, PU-PH, and <strong>Dr Quentin Lepiller</strong>, MUCU-PH, collaborator answered some of our questions.
          </p>
          <strong>Key take-aways:</strong>
          <ListGroup>
            <ListGroup.Item>The viral load required for infection to occur is not known in the context of HPV (i.e. it varies a lot).</ListGroup.Item>
            <ListGroup.Item>Our chosen targets and experimental strategy are appropriate. We could also consider targeting L2.</ListGroup.Item>
            <ListGroup.Item>Our product should not be commercialized to replace condoms.</ListGroup.Item>
            <ListGroup.Item>We must think about viral evolution, both as a force for good (targeting multiple types) and for bad (encouraging higher virulence).</ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
    </Container>
  );
}

const GFPphage=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            Dr. Arnaud Gutierrez of Institut Cochin generously provided us with
            fluorescently labelled T4 bacteriophage (tagged with sfGFP), with
            which we could visualize the diffusion of viral particles in mucin
            solution and also could potentially visualize interactions in binding
            kinetics assessments, such as in Microscale thermophoresis (MST)
            which require at least one of the binding partners to be
            fluorescently labeled. Unfortunately, we were unable to utilize them
            in the timeframe of our iGEM project, but we plan to do so in our
            further study.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const otherGuy=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            D.J. Shon, previously a PhD student at Stanford University, was
            contacted regarding her study of the mucin binder StcE_E447D. She
            and her former colleague G.S. Tender generously aided us in our
            search for good candidates for mucin binders and directed towards
            the X409 subunit of StcE, a much smaller and inactive enzyme which
            retains strong binding capacity.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

const England=()=>
{
  return (
    <Container>
      <Row>
        <Col>
          <p>
            We met with Patrick England and Bertrand Raynal from the England Lab,
            the molecular biophysics lab at Pasteur. Bertrand Raynal had completed
            his PhD on mucin specifically.
          </p>
        </Col>
      </Row>
    </Container>
  );
}





  const SpeakerCard = ({  index, onReadMoreClick, bubbleData, componentIndex}) => {
  const componentsArray = [
    Initial, WhitePaper, FranceSexualHealth, EUSexualHealth, Frameworks,
     PublicHealthDefinitions, hiddenliveshiddengems, Exposees, Tickson, 
    Facettes, PopCulture, PatientX, Akuma, Gyneco, Claire, Lusignan,
     Slow, Dolbois, Gibert, Elena, Tessa, Valentin, Morel, Antoine,
      Outreach, Microbicides, Harvard, Ethics, Auvert, Baker, Bomsel,
       CNPR, GFPphage, otherGuy, England
  ]
  const ComponentToRender = componentsArray[componentIndex];
  console.log(componentsArray)
  return (
    <div className='speaker-card'>
    <Card   className="mb-2"    >
    <Card.Img style={{width: 'auto', height:"100px"}}variant="top" src={bubbleData[index]?.imageUrl} />

    <Card.Body>
      <Card.Title>{bubbleData[index]?.header}</Card.Title>
      <Card.Text>
      {ComponentToRender && <ComponentToRender />}
      </Card.Text>
      <Button  variant="dark" onClick={() => onReadMoreClick(index)}>Read More</Button>
    </Card.Body>
  </Card>
  </div>
  );
};

export default SpeakerCard;
